// Module
var code = "<div class=\"pageLayout\"> <div class=\"pageLayout_item\" role=\"main\"> <slot name=\"header\"></slot> <div class=\"pageLayout_content\"> <slot name=\"main\"></slot> </div> </div> <div v-if=\"$slots.sidebar\" :aria-label=\"t('thankYou_summary')\" class=\"pageLayout_item\" role=\"complementary\"> <slot name=\"sidebar\"></slot> </div> </div> ";
// Exports
export default code;